import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneashtavinayakdarshan() {



  const cardData =
  {
    keyword: 'Pune Ashtavinayak Darshan Tour Package',
    heading: 'Sanavi Travels: Pune Ashtavinayak Darshan Tour Package',
    headingDescription: 'Sanavi Travels offers the best Pune Ashtavinayak Darshan Tour Package, providing comfortable, safe, and well-organized travel for devotees visiting all eight sacred Ashtavinayak temples around Pune. Our package includes AC and Non-AC buses, tempo travellers, and luxury coaches with professional chauffeurs, ensuring smooth and hassle-free journeys with ample seating and luggage space. With flexible one-day and multi-day packages, transparent pricing, pickup and drop services from Pune, and 24/7 support, the tour is ideal for families, groups, and pilgrims seeking a spiritual and convenient experience. Choose Sanavi Travels for a trusted and seamless Ashtavinayak Darshan Tour from Pune, combining comfort, safety, and devotion in a well-planned itinerary.',

    top: 'Top Places to Visit in Ashtavinayak with Sanavi Travels',


"topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Morgaon is considered the starting point of the Ashtavinayak pilgrimage and houses the Mayureshwar Temple dedicated to Lord Ganesha. The temple, situated on the banks of the river, features intricate carvings, a gold-plated idol, and a serene environment. Pilgrims believe visiting Mayureshwar fulfills wishes and brings spiritual blessings. The temple is especially vibrant during Ganesh Chaturthi, attracting thousands of devotees."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "The Siddhivinayak Temple at Siddhatek is a prominent Ganesha shrine located on the banks of the Bhima River. Known for granting ‘siddhi’ or success, this temple is set atop a small hill, providing a panoramic view of the surrounding landscape. The climb is considered a spiritual journey, and the temple hosts numerous devotees throughout the year."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Ballaleshwar Ganesha Temple in Pali is unique for its legend of the devotee Ballal, whose unwavering devotion impressed Lord Ganesha. The temple’s architecture showcases traditional Maharashtrian style, and the idol is adorned with gold and jewels. Pilgrims visit to seek blessings for devotion, prosperity, and spiritual guidance."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Varadvinayak Temple in Mahad is revered for granting boons and fulfilling wishes. Set amidst a lush backdrop, the temple features intricate carvings and a large hall for devotees. Festivals like Ganesh Chaturthi see elaborate celebrations with rituals, music, and community offerings."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Chintamani Temple in Theur is dedicated to Lord Ganesha, known for removing worries and obstacles. The temple, adorned with ancient carvings and a gold-plated idol, sits in a serene village setting. Pilgrims visit to perform rituals and seek relief from personal and professional challenges."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Lenyadri Temple, carved into a Buddhist rock-cut cave, houses Lord Ganesha as Girijatmaj. The temple is part of a serene hillside, offering a spiritual atmosphere and panoramic views. The climb to the cave involves narrow steps and rocky pathways, enhancing the pilgrimage experience."
  },
  {
    "title": "Vigneshwar Temple, Ozar",
    "description": "Ozar’s Vigneshwar Temple is situated along the banks of the Kukadi River and is known for granting protection and prosperity. The temple’s traditional architecture, riverfront setting, and festivals make it a significant stop in the Ashtavinayak circuit."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "Ranjangaon Mahaganapati Temple houses a powerful Ganesha idol worshipped for success, wisdom, and victory. The temple’s expansive courtyard, surrounding greenery, and festival celebrations attract pilgrims, tourists, and spiritual seekers alike."
  },
  {
    "title": "Ashtavinayak Pilgrimage Route",
    "description": "The Ashtavinayak circuit connects all eight sacred temples dedicated to Lord Ganesha across Pune and neighboring districts. Pilgrims follow a clockwise route starting from Morgaon, covering sacred rivers, forts, and villages along the way. The journey combines spiritual devotion, cultural heritage, and scenic landscapes."
  },
  {
    "title": "Cultural and Spiritual Significance",
    "description": "Visiting the Ashtavinayak temples is considered highly auspicious and spiritually enriching. The pilgrimage showcases Maharashtra’s religious traditions, folk culture, and architectural heritage, making it an immersive experience for devotees, historians, and travelers seeking both devotion and scenic beauty."
  }
]
,



"services": [
{
"name": "Pune Ashtavinayak Darshan Tour Package",
"description": "Pune Ashtavinayak Darshan Tour Package offers a complete and well-organized itinerary covering all eight Ashtavinayak temples. Designed for devotees, families, and groups, this package provides comfortable transportation, professional drivers, guided schedules, and timely pickups and drops. It ensures a hassle-free spiritual journey from Pune, combining convenience, safety, and devotion for a memorable pilgrimage experience."
},
{
"name": "Ashtavinayak Bus Tour Pune",
"description": "Ashtavinayak Bus Tour Pune provides spacious and comfortable buses for group travel to all Ashtavinayak temples. With professional drivers, flexible itineraries, and modern amenities, it caters to families, friends, corporate groups, and devotees, ensuring a smooth, safe, and enjoyable religious tour experience from Pune and nearby locations."
},
{
"name": "Ashtavinayak Tempo Traveller Pune",
"description": "Ashtavinayak Tempo Traveller Pune offers private tempo travellers for small groups and families who prefer a personalized Ashtavinayak pilgrimage. Featuring air-conditioning, ample luggage space, and professional drivers, it ensures a comfortable, flexible, and convenient journey to all temples, making it ideal for devotees seeking privacy and comfort."
},
{
"name": "AC Ashtavinayak Tour",
"description": "AC Ashtavinayak Tour provides air-conditioned vehicles for a refreshing and comfortable pilgrimage experience. Perfect for long-day trips and family travel, these vehicles offer ample seating, climate control, professional drivers, and smooth navigation, ensuring devotees enjoy a relaxed and pleasant journey across all Ashtavinayak temples."
},
{
"name": "Luxury Ashtavinayak Package",
"description": "Luxury Ashtavinayak Package offers premium vehicles, personalized itineraries, and professional chauffeurs for devotees and tourists seeking a top-tier pilgrimage experience. Equipped with modern amenities, spacious seating, and comfort-focused service, it guarantees a safe, luxurious, and memorable Ashtavinayak tour from Pune."
},
{
"name": "Religious Tour Package Pune",
"description": "Religious Tour Package Pune is designed for devotees and pilgrims wishing to explore Ashtavinayak temples along with other nearby spiritual destinations. The package includes organized itineraries, experienced drivers, comfortable vehicles, and hassle-free arrangements, ensuring a peaceful and fulfilling religious journey from Pune."
},
{
"name": "Family Ashtavinayak Trip",
"description": "Family Ashtavinayak Trip provides safe, comfortable, and spacious vehicles for family pilgrimages. With professional drivers, flexible timings, and a focus on convenience and comfort, this package ensures that families can enjoy the spiritual journey together, with a memorable and hassle-free experience."
},
{
"name": "Group Travel Ashtavinayak",
"description": "Group Travel Ashtavinayak offers organized bus and tempo traveller options for corporate groups, friends, and social clubs wishing to visit all Ashtavinayak temples. With coordinated itineraries, experienced drivers, and modern vehicles, it ensures smooth, safe, and enjoyable group pilgrimages from Pune."
},
{
"name": "Affordable Ashtavinayak Tour",
"description": "Affordable Ashtavinayak Tour provides budget-friendly travel solutions without compromising comfort or safety. Ideal for families, solo travelers, and small groups, it offers reliable vehicles, professional drivers, and organized itineraries for a cost-effective yet memorable pilgrimage experience."
},
{
"name": "Chauffeur Driven Tour Vehicle",
"description": "Chauffeur Driven Tour Vehicle ensures a stress-free Ashtavinayak pilgrimage with professional drivers managing navigation, traffic, and schedules. Perfect for families, groups, and corporate clients, it provides comfortable, safe, and well-maintained vehicles for a smooth journey across all temples."
},
{
"name": "Best Ashtavinayak Package Pune",
"description": "Best Ashtavinayak Package Pune guarantees high-quality vehicles, punctual service, professional drivers, and carefully planned itineraries. Designed for devotees, families, and tourists, it provides a reliable, comfortable, and memorable pilgrimage experience covering all eight Ashtavinayak temples from Pune."
},
{
"name": "One Day Ashtavinayak Tour",
"description": "One Day Ashtavinayak Tour is ideal for travelers seeking a quick and organized pilgrimage. Covering key temples in a single day, it provides comfortable transport, professional drivers, and timely coordination to ensure devotees experience a hassle-free and fulfilling spiritual journey."
},
{
"name": "Two Day Ashtavinayak Trip",
"description": "Two Day Ashtavinayak Trip offers a relaxed and detailed itinerary covering all temples over two days. Perfect for families, senior citizens, and devotees wanting a comfortable pace, the package includes overnight stops, professional drivers, and convenient transportation for a safe and enjoyable spiritual experience."
},
{
"name": "Online Booking Ashtavinayak",
"description": "Online Booking Ashtavinayak allows devotees and travelers to reserve their Ashtavinayak tour quickly and conveniently. With instant confirmation, multiple vehicle options, transparent pricing, and flexible scheduling, it makes planning the pilgrimage from Pune simple, reliable, and hassle-free."
},
{
"name": "Ganpati Darshan Tour Pune",
"description": "Ganpati Darshan Tour Pune offers dedicated tours to the famous Ashtavinayak temples and other Ganpati sites around Pune. With professional drivers, spacious and comfortable vehicles, organized itineraries, and flexible travel options, it provides a memorable and spiritually enriching experience for families, groups, and devotees."
}
],
"tableData": [
["Pune Ashtavinayak Darshan Tour Package", "Ashtavinayak Bus Tour Pune"],
["Ashtavinayak Tempo Traveller Pune", "AC Ashtavinayak Tour"],
["Luxury Ashtavinayak Package", "Religious Tour Package Pune"],
["Family Ashtavinayak Trip", "Group Travel Ashtavinayak"],
["Affordable Ashtavinayak Tour", "Chauffeur Driven Tour Vehicle"],
["Best Ashtavinayak Package Pune", "One Day Ashtavinayak Tour"],
["Two Day Ashtavinayak Trip", "Online Booking Ashtavinayak"],
["Ganpati Darshan Tour Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Jejuri Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Jejuri Pune, ideal for group outings, family trips, pilgrimages, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Jejuri Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are well‑versed with Jejuri Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Jejuri Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Jejuri Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Jejuri Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Jejuri Pune?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Jejuri Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Jejuri Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Jejuri Pune?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Jejuri Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Jejuri Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Jejuri Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Jejuri Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Jejuri Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Jejuri Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Jejuri Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    feedback: 'Booked a bus in Jejuri Pune with Sanavi Travels — very comfortable bus and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rekha Shinde',
    feedback: 'Sanavi Travels made our group trip in Jejuri Pune smooth and stress‑free. Highly recommended!',
    rating: 5
  }
];































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Pune Ashtavinayak Darshan Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune Ashtavinayak Darshan tour packages with AC buses, Tempo Travellers, and luxury vehicles. Family trips, group travel, and religious tours with affordable, chauffeur-driven service. One-day and two-day packages available with online booking.",
  "touristType": "Religious Tour",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "32"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Pune Ashtavinayak Darshan Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune Ashtavinayak Darshan tour package with Sanavi Travels. AC buses, Tempo Travellers, luxury options for family & group trips. One-day and two-day religious tours with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/153.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneashtavinayakdarshan;